export default "__VITE_ASSET__DWxmW_wR__"